import React from 'react';

import { TFunction, useTranslation } from '@lyearn/i18n';
import { CheckmarkSquare2Outline, Image, Settings3Outline, Shuffle, Text } from '@lyearn/icons';

import BaseLimitedEditingModal from '../BaseLimitedEditingModal';
import { LimitedEditingModalProps } from '../types';

const getContent = (t: TFunction) => [
  { Icon: Text, label: t('QuizCreator:LimitedEditingModal.QuestionLabel') },
  { Icon: Image, label: t('QuizCreator:LimitedEditingModal.MediaLabel') },
  { Icon: Shuffle, label: t('QuizCreator:LimitedEditingModal.ShuffleOptionsLabel') },
  {
    Icon: CheckmarkSquare2Outline,
    label: t('QuizCreator:LimitedEditingModal.ChangeCorrectAnswers'),
  },
  {
    Icon: Settings3Outline,
    label: t('QuizCreator:LimitedEditingModal.ModifyQuizLevelSettings'),
  },
];

function LimitedEditingModalQuiz(props: LimitedEditingModalProps) {
  const { t } = useTranslation();
  const { onClose } = props;

  return (
    <BaseLimitedEditingModal
      content={getContent(t)}
      description={t('QuizCreator:LimitedEditingModal.PublishedQuizDescription')}
      onClose={onClose}
    />
  );
}

export default LimitedEditingModalQuiz;
